/* eslint-disable */

export enum LendingStatus {
  /** NOT_A_LENDING_CUSTOMER - The customer has never been offered a credit line. */
  NOT_A_LENDING_CUSTOMER = "NOT_A_LENDING_CUSTOMER",
  /**
   * CREDIT_LINE_OFFERED - The customer has been offered a credit line, but not accepted it. It's possible that the
   * customer has a previous closed or retract credit line.
   */
  CREDIT_LINE_OFFERED = "CREDIT_LINE_OFFERED",
  /**
   * CREDIT_LINE_RETRACTED - The customer's credit line offer was retracted. It's possible that the customer has a previous
   * closed or retracted credit line.
   */
  CREDIT_LINE_RETRACTED = "CREDIT_LINE_RETRACTED",
  /**
   * CREDIT_LINE_ACTIVATED - Deprecated.
   *
   * @deprecated
   */
  CREDIT_LINE_ACTIVATED = "CREDIT_LINE_ACTIVATED",
  /** CREDIT_LINE_ACTIVE - The customer's credit line is active and they have at least one active loan. */
  CREDIT_LINE_ACTIVE = "CREDIT_LINE_ACTIVE",
  /** CREDIT_LINE_IDLE - The customer's credit line is active but they have no outstanding loans. */
  CREDIT_LINE_IDLE = "CREDIT_LINE_IDLE",
  /** CREDIT_LINE_OVERDUE - The customer's credit line is active and they have at least one overdue loan. */
  CREDIT_LINE_OVERDUE = "CREDIT_LINE_OVERDUE",
  /** CREDIT_LINE_CLOSED - The customer's credit line is closed. */
  CREDIT_LINE_CLOSED = "CREDIT_LINE_CLOSED",
}
